export const configure = {
  backendUrl: "https://q340zrn3dk.execute-api.us-west-2.amazonaws.com",
  backendUrlUMT: "https://o7qtx7i126.execute-api.us-west-2.amazonaws.com/dev",
  poolData: {
    UserPoolId: "us-west-2_CXaXtTynn",
    ClientId: "2oacoiaap6adefq6r9hq9c2aoi"
  },
  indentityPoolId: "us-west-2:65ffd913-736f-46a9-9942-e169ecee558c",
  endpoint: "lfts-storage-dev",
  region: "us-west-2",
  cognito_id: `cognito-idp.us-west-2.amazonaws.com/`,
  s3Credentials: {
    indentityPoolId: "us-west-2:65ffd913-736f-46a9-9942-e169ecee558c"
  },
  S3Config: {
    endpoint: "lfts-storage-dev", //s3Endpoint,
    credentials: {
      indentityPoolId: "us-west-2:65ffd913-736f-46a9-9942-e169ecee558c"
    }
  },
};
